import { render, staticRenderFns } from "./SendOrderShopeeBatch.vue?vue&type=template&id=5a8dc679&scoped=true"
import script from "./SendOrderShopeeBatch.vue?vue&type=script&lang=js"
export * from "./SendOrderShopeeBatch.vue?vue&type=script&lang=js"
import style0 from "./SendOrderShopeeBatch.vue?vue&type=style&index=0&id=5a8dc679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dc679",
  null
  
)

export default component.exports